import { render, staticRenderFns } from "./CommunityOrders.vue?vue&type=template&id=bb77e6c8&"
import script from "./CommunityOrders.vue?vue&type=script&lang=ts&"
export * from "./CommunityOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports